import { useState, useEffect, useCallback } from 'react';
import api from '@/shared/services/api';

export interface Relationships {
  id: number;
  name: string;
}

interface UseRelationshipsReturn {
  relationships: Relationships[];
  relationshipsOptions: string[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useRelationships = (): UseRelationshipsReturn => {
  const [relationships, setRelationships] = useState<Relationships[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRelationships = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get('api/relationships/all');

      if (response.data.success && response.data.relationships) {
        // sort A → Z by name
        const sortedRelationships = response.data.relationships.sort(
          (a: Relationships, b: Relationships) => a.name.localeCompare(b.name)
        );

        setRelationships(sortedRelationships);
        console.log(sortedRelationships);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Error fetching relationships:', err);
      setError('Failed to fetch relationships');
    } finally {
      setLoading(false);
    }
  }, []); // No dependencies needed since api and setters are stable

  useEffect(() => {
    fetchRelationships();
  }, [fetchRelationships]); // ✅ Now includes the dependency

  // Convert relationships options format for dropdowns (already sorted)
  const relationshipsOptions = relationships.map(tp => tp.name);

  return {
    relationships,
    relationshipsOptions,
    loading,
    error,
    refetch: fetchRelationships
  };
};